const movieQuotes = [
  {
    quote: "Cinema is truth twenty-four times per second.",
    author: "Jean-Luc Godard",
  },
  {
    quote: "Movies touch our hearts and awaken our vision.",
    author: "Martin Scorsese",
  },
  {
    quote: "Every film should have its own world.",
    author: "Christopher Nolan",
  },
  {
    quote: "The cinema has no boundary; it is a ribbon of dream.",
    author: "Orson Welles",
  },
  {
    quote: "A story should have a beginning, a middle and an end, but not necessarily in that order.",
    author: "Jean-Luc Godard",
  },
  {
    quote: "Film is one of the three universal languages.",
    author: "Frank Capra",
  },
  {
    quote: "The best films are dream films.",
    author: "Ingmar Bergman",
  },
  {
    quote: "Cinema is a matter of what's in the frame and what's out.",
    author: "Martin Scorsese",
  },
  {
    quote: "A film is never really good unless the camera is an eye in the head of a poet.",
    author: "Orson Welles",
  },
  {
    quote: "People will surprise you if you give them a chance.",
    author: "David Lynch",
  },
  {
    quote: "Cinema should make you forget you are sitting in a theater.",
    author: "Roman Polanski",
  },
  {
    quote: "Movies can and do have tremendous influence.",
    author: "Roger Ebert",
  },
  {
    quote: "The eye should learn to listen before it looks.",
    author: "Robert Bresson",
  },
  {
    quote: "A filmmaker has almost the same freedom as a novelist has when he buys himself some paper.",
    author: "Stanley Kubrick",
  },
  {
    quote: "Film lovers are sick people.",
    author: "François Truffaut",
  },
  {
    quote: "Cinema is memory.",
    author: "Andrei Tarkovsky",
  },
  {
    quote: "To make a film is easy. To make a good film is war.",
    author: "Alejandro González Iñárritu",
  },
  {
    quote: "Movies are like an expensive form of therapy for me.",
    author: "Tim Burton",
  },
  {
    quote: "The screen is a magic medium.",
    author: "Stanley Kubrick",
  },
  {
    quote: "Film is a battleground.",
    author: "Sam Fuller",
  },
  {
    quote: "Cinema is the most beautiful fraud in the world.",
    author: "Jean-Luc Godard",
  },
  {
    quote: "Art consists of limitation.",
    author: "G. K. Chesterton",
  },
  {
    quote: "A great film should seem new every time you see it.",
    author: "Roger Ebert",
  },
  {
    quote: "The best way to learn filmmaking is by making a film.",
    author: "Stanley Kubrick",
  },
  {
    quote: "Fear is the thing that keeps you from doing your best work.",
    author: "David Lynch",
  },
  {
    quote: "Stories only happen to those who are able to tell them.",
    author: "Paul Auster",
  },
  {
    quote: "No art passes our conscience in the way film does.",
    author: "Ingmar Bergman",
  },
  {
    quote: "Cinema is a mirror by which we often see ourselves.",
    author: "Alejandro González Iñárritu",
  },
  {
    quote: "Film music should have the same relationship to the film drama that somebody's piano playing in my living room has to the book I am reading.",
    author: "Igor Stravinsky",
  },
  {
    quote: "You don't make a photograph just with a camera.",
    author: "Ansel Adams",
  },
  {
    quote: "A movie is a little like a question, and when you make it, that's when you get the answer.",
    author: "Francis Ford Coppola",
  },
  {
    quote: "There is no end. There is no beginning. There is only the infinite passion of life.",
    author: "Federico Fellini",
  },
  {
    quote: "The best films are made by obsession.",
    author: "Martin Scorsese",
  },
  {
    quote: "Cinema is a way of thinking.",
    author: "Theo Angelopoulos",
  },
  {
    quote: "Every cut is a lie.",
    author: "Jean-Luc Godard",
  },
  {
    quote: "A good film is when the price of the dinner, the theatre admission and the babysitter were worth it.",
    author: "Alfred Hitchcock",
  },
  {
    quote: "Drama is life with the dull bits cut out.",
    author: "Alfred Hitchcock",
  },
  {
    quote: "Film as dream, film as music.",
    author: "Ingmar Bergman",
  },
  {
    quote: "People like to say that the conflict is between good and evil. The real conflict is between truth and lies.",
    author: "Don Miguel Ruiz",
  },
  {
    quote: "The purpose of art is washing the dust of daily life off our souls.",
    author: "Pablo Picasso",
  },
  {
    quote: "Cinema is a language.",
    author: "Marcel Martin",
  },
  {
    quote: "Movies are memories.",
    author: "Pedro Almodóvar",
  },
  {
    quote: "Nothing happens in the world? That's exactly what happens.",
    author: "Chantal Akerman",
  },
  {
    quote: "Every frame is a painting.",
    author: "Nicolas Winding Refn",
  },
  {
    quote: "You have to be brave to make films.",
    author: "Claire Denis",
  },
  {
    quote: "The image is more than an idea.",
    author: "Andrei Tarkovsky",
  },
  {
    quote: "Watching a movie from beginning to end is like reading a book.",
    author: "Guillermo del Toro",
  },
  {
    quote: "Cinema is a place for dreams.",
    author: "Hayao Miyazaki",
  },
  {
    quote: "The world is full of lonely people afraid to make the first move.",
    author: "Tony Lip",
  },
  {
    quote: "Film is emotion through light.",
    author: "Vittorio Storaro",
  },
  {
    quote: "Movies are a machine that generates empathy.",
    author: "Roger Ebert",
  },
  {
    quote: "Cinema is a mirror of dreams.",
    author: "Bernardo Bertolucci",
  },
  {
    quote: "Life is in color, but black and white is more realistic.",
    author: "Samuel Fuller",
  },
  {
    quote: "There are no rules in filmmaking.",
    author: "Lars von Trier",
  },
  {
    quote: "Movies are the memories of our lifetime.",
    author: "Martin Scorsese",
  },
  {
    quote: "A film should be more like music than like fiction.",
    author: "Stanley Kubrick",
  },
  {
    quote: "To me, cinema is not a slice of life, but a piece of cake.",
    author: "Alfred Hitchcock",
  },
  {
    quote: "The cinema is an invention without a future.",
    author: "Louis Lumière",
  },
  {
    quote: "Sometimes reality is too complex for oral communication.",
    author: "Alain Resnais",
  },
  {
    quote: "Cinema is a weapon.",
    author: "Patrice Lumumba",
  },
  {
    quote: "The cinema substitutes for our gaze a world more in harmony with our desires.",
    author: "André Bazin",
  },
  {
    quote: "Film is one of the ways of understanding what it means to be human.",
    author: "Alexander Payne",
  },
  {
    quote: "Cinema begins with Griffith and ends with Abbas Kiarostami.",
    author: "Jean-Luc Godard",
  },
  {
    quote: "The filmmaker's responsibility is to remain true to emotion.",
    author: "Céline Sciamma",
  },
  {
    quote: "Art is not a mirror held up to reality but a hammer with which to shape it.",
    author: "Bertolt Brecht",
  },
  {
    quote: "Cinema is a matter of style.",
    author: "Wong Kar-wai",
  },
  {
    quote: "Nothing in life is as important as you think it is while you are thinking about it.",
    author: "Daniel Kahneman",
  },
  {
    quote: "Movies are never finished, only abandoned.",
    author: "George Lucas",
  },
  {
    quote: "Film is a way of seeing.",
    author: "Agnès Varda",
  },
  {
    quote: "The audience completes the film.",
    author: "David Fincher",
  },
  {
    quote: "Cinema is poetry with light.",
    author: "Akira Kurosawa",
  },
  {
    quote: "A movie should move people.",
    author: "Steven Spielberg",
  },
  {
    quote: "The best films are the ones you carry home with you.",
    author: "Roger Ebert",
  },
  {
    quote: "Film is a journey into the unknown.",
    author: "Werner Herzog",
  },
  {
    quote: "Cinema is an empathy machine.",
    author: "Roger Ebert",
  },
  {
    quote: "Stories are how we understand the world.",
    author: "Greta Gerwig",
  },
  {
    quote: "The image is the soul of cinema.",
    author: "Béla Tarr",
  },
  {
    quote: "The camera is an instrument that teaches people how to see.",
    author: "Dorothea Lange",
  },
  {
    quote: "Movies are dreams you never forget.",
    author: "Denis Villeneuve",
  },
  {
    quote: "A film lives in the tension between what is shown and what is hidden.",
    author: "Park Chan-wook",
  },
  {
    quote: "Cinema is emotion sculpted in time.",
    author: "Andrei Tarkovsky",
  },
  {
    quote: "Movies let us live a thousand lives.",
    author: "Guillermo del Toro",
  },
  {
    quote: "Every audience deserves honesty.",
    author: "Barry Jenkins",
  },
  {
    quote: "The best stories feel like memories.",
    author: "Richard Linklater",
  },
  {
    quote: "Cinema is a conversation with the night.",
    author: "Leos Carax",
  },
  {
    quote: "Film is light trapped in emotion.",
    author: "Emmanuel Lubezki",
  },
  {
    quote: "A quiet film can still shake the world.",
    author: "Yasujiro Ozu",
  },
  {
    quote: "Movies teach us how to feel time.",
    author: "Kelly Reichardt",
  },
  {
    quote: "Cinema belongs to those who look closely.",
    author: "Agnès Varda",
  },
  {
    quote: "A movie can become part of someone’s inner life.",
    author: "Paul Thomas Anderson",
  },
  {
    quote: "The night changes when the right movie starts.",
    author: "Wong Kar-wai",
  },
  {
    quote: "Film is memory illuminated.",
    author: "Theo Angelopoulos",
  },
  {
    quote: "Every frame carries emotion.",
    author: "Luca Guadagnino",
  },
  {
    quote: "Cinema slows the world down long enough for us to notice it.",
    author: "Jim Jarmusch",
  },
  {
    quote: "Movies are small rooms we escape into together.",
    author: "Noah Baumbach",
  },
  {
    quote: "The beauty of cinema is its silence between words.",
    author: "Sofia Coppola",
  },
  {
    quote: "Film is the closest thing we have to dreaming together.",
    author: "Alejandro Jodorowsky",
  },
  {
    quote: "Good cinema lingers after the credits.",
    author: "Bong Joon-ho",
  },
  {
    quote: "Cinema is mood before meaning.",
    author: "David Lynch",
  },
  {
    quote: "Movies are fragments of time we keep forever.",
    author: "Terrence Malick",
  },
  {
    quote: "The right film can make solitude feel beautiful.",
    author: "Haruki Murakami",
  },
];

export default movieQuotes;